import type { ComponentProps } from "react"
import { DropdownMenuContent as DropdownMenuBaseContentBase } from "@/v2-ui/dropdownMenu/base/DropdownMenuBase"
import DropdownMenuPortal from "./DropdownMenuPortal"
import { useQuerySelectorLazy } from "../utils/utils.dom"
import cn from "../utils/utils.cn"

const DEAFAULT_PORTAL_CONTAINER = "#mount"

export type DropdownMenuContentProps = ComponentProps<
  typeof DropdownMenuBaseContentBase
> & {
  portalContainer?: string
}

function DropdownMenuContent(props: DropdownMenuContentProps) {
  const {
    portalContainer = DEAFAULT_PORTAL_CONTAINER,
    className,
    ...dropdownMenuBaseContentBaseProps
  } = props
  const portalElem = useQuerySelectorLazy(portalContainer)

  return (
    <DropdownMenuPortal container={portalElem}>
      <DropdownMenuBaseContentBase
        className={cn("ui-dropdown-menu-content", className)}
        {...dropdownMenuBaseContentBaseProps}
      />
    </DropdownMenuPortal>
  )
}

export default DropdownMenuContent
